import axios, { AxiosResponse } from "axios";

import { store } from "@/store";
import { VUE } from "@/main";

import { SERVER_API_URL } from "@/constants";
import { ApiError } from "@/core/error/interface/api-error.interface";

const TIMEOUT = 1000000;
const onRequestSuccess = (config) => {
  const token =
    localStorage.getItem("jhi-authenticationToken") ||
    sessionStorage.getItem("jhi-authenticationToken");
  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.timeout = TIMEOUT;
  config.url = `${SERVER_API_URL}${config.url}`;
  return config;
};
const setupAxiosInterceptors = (onUnauthenticated) => {
  // Lazily resolved to avoid a circular import at module-eval time:
  // config.ts -> axios-interceptor.ts -> store.ts -> config.ts. Both are only
  // needed once the interceptors actually run, well after modules are loaded.
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const onResponseError = (err) => {
    const status = err.status || err.response.status;

    if ([500, 422, 423, 409, 404, 403, 400].includes(status)) {
      throw new ApiError(err.response.data);
    }

    if (status === 401 && !store.state.authenticated) {
      // return getModule(AuthStore).aRefresh().then(async () => {
      //   return axios.request({
      //     ...error.config,
      //     headers: ApiService.HEADERS(),
      //   });
      // }).catch(() => {
      //   // The user should be logged out by now, so this shouldn't happen.
      // });
    }

    if (status === 403 || status === 401) {
      onUnauthenticated();
    }
    return Promise.reject(err);
  };

  function getMessageFromHeader(res: any): any {
    let param = res.headers["x-insightsapp-params"];
    param = param ? decodeURIComponent(param.replace(/\+/g, " ")) : undefined;
    return VUE.$t(res.headers["x-insightsapp-alert"], {
      param,
    });
  }

  const onResponseSuccess = (response: AxiosResponse) => {
    if (response.headers["x-insightsapp-alert"]) {
      const message = getMessageFromHeader(response);
      VUE.$root.$bvToast.toast(message, {
        toaster: "b-toaster-top-right",
        variant: response.headers["x-insightsapp-alert"].endsWith(".deleted")
          ? "danger"
          : "info",
        autoHideDelay: 5000,
      });
    }
    return response;
  };
  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(onResponseSuccess, onResponseError);
  }
};

export { onRequestSuccess, setupAxiosInterceptors };
